import { TextWrapper, TextWrapperProps } from "@/components/TextWrapper";

import { CPT_COPYRIGHT_NOTICE } from "../constants";

type CptCopyrightNoticeProps = Omit<TextWrapperProps, "children">;

/** The AMA CPT copyright notice for screens that show CPT codes. */
export function CptCopyrightNotice(props: CptCopyrightNoticeProps) {
  return (
    <TextWrapper size="md" lh="20px" c="gray.6" data-testid="cpt-copyright-notice" {...props}>
      {CPT_COPYRIGHT_NOTICE}
    </TextWrapper>
  );
}
